import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers';


const logger = store => next => (action) => {
  console.group(action.type);
  console.info('dispatching', action);
  const result = next(action);
  console.log('next state', store.getState());
  console.groupEnd(action.type);
  return result;
};

const createStoreWithMiddleware = applyMiddleware(
  thunkMiddleware,
  //logger,
)(createStore);


export default function configureStore(initialState) {
  return createStoreWithMiddleware(rootReducer, initialState);
}



/** WEBPACK FOOTER **
 ** ./src/pages/ucBindEmail/store/index.js
 **/